import styled from '@emotion/styled';
import { motion } from 'framer-motion';

export const Toast = styled(motion.div)({
  position: 'fixed',
  bottom: '5%',
  left: '50%',
  zIndex: 1000,
  borderRadius: '100px',
  background: 'rgba(86, 93, 97, 0.80)',
  backdropFilter: 'blur(15px)',
  display: 'inline-flex',
  padding: '10px 18px',
  alignItems: 'center',
  gap: '4px',
});
